import c from 'classnames';
import { Typography } from '#components';

import styles from './Card.module.css';

export const Card = ({
  title = '',
  id,
  className = '',
  variant = 'normal',
  onClick,
  children,
}: {
  title?: React.ReactNode;
  id?: string;
  className?: string;
  variant?: 'normal' | 'wrapper';
  onClick?: (event: React.MouseEvent) => void;
  children?: React.ReactNode;
}) => {
  return (
    <div
      id={id}
      className={c(
        className,
        styles.cardWrapper,
        variant,
        onClick ? styles.hover : '',
      )}
      onClick={onClick}
    >
      {title && (
        <>
          <div
            className={c(
              styles.cardSection,
              styles.cardHeader,
              title ? styles.headerMargin : '',
            )}
          >
            <Typography variant='heading-m'>{title}</Typography>
          </div>
          <div className={c(styles.cardBody, styles.cardSection)}>
            <div className={c('flex flex-column h-100')}>{children}</div>
          </div>
        </>
      )}

      {!title && (
        <div className={c(styles.cardBody, 'h-100')}>
          <div className={c('flex flex-column h-100')}>{children}</div>
        </div>
      )}
    </div>
  );
};
